import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toolByRoute } from '../domain/tools/registry';
import { localize } from '../domain/tools/types';
import { useLanguage } from '../features/language/useLanguage';

export function DocumentTitle() {
  const location = useLocation();
  const { t } = useTranslation();
  const { language } = useLanguage();

  useEffect(() => {
    const tool = toolByRoute.get(location.pathname);
    const section = tool ? localize(tool.name, language) : location.pathname === '/' ? t('app.tagline') : location.pathname.startsWith('/settings') ? t('settings.title') : t('toolLibrary.title');
    document.title = `${section} · Satr PDF`;
  }, [location.pathname, language, t]);

  return null;
}
